exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li.col-item[data-v-160353ff]{list-style:none}li.col-item span.col-span-title[data-v-160353ff]{display:inline-block;font-size:13px;width:120px}li.col-item .col-delete-button[data-v-160353ff]{margin-left:6px}\n", ""]);

// exports
